import { useSelector } from 'react-redux';
import cc from 'classcat';
import { RootState } from '../../../store';
import { Button } from '..';

interface IYesNo {
    title: string;
    className?: string;
    description?: string;
    onYes: () => void;
    onNo: () => void;
    isNoContained?: boolean;
    danger?: boolean;
    yesLabel?: string;
    noLabel?: string;
}

export const YesNo = ({ title, className, description, onYes, onNo, isNoContained = false, danger, yesLabel, noLabel }: IYesNo) => {
    const content = useSelector((state: RootState) => state.language.data);

    return (
        <div className={cc(['yes-no', { 'yes-no--danger': danger }, className])}>
            <h3 className="yes-no__title">{title}</h3>
            {description && <p className={cc(['yes-no__description', 'paragraph-3'])}>{description}</p>}
            <div className="yes-no__buttons">
                <Button onClick={onNo} text={noLabel ?? content.common.no} variant={isNoContained ? 'contained' : 'text'} color="blue" />
                <Button text={yesLabel ?? content.common.yes} onClick={onYes} variant={danger ? 'danger' : isNoContained ? 'text' : 'contained'} />
            </div>
        </div>
    );
};
